/** Storage that never throws: private windows, blocked site data and quota errors all
 * degrade to "not remembered" instead of breaking the page. */
export function readStore<T>(store: "local" | "session", key: string, fallback: T, guard: (v: unknown) => v is T): T {
  try {
    const s = store === "local" ? window.localStorage : window.sessionStorage;
    const raw = s.getItem(key);
    if (raw === null) return fallback;
    const parsed: unknown = JSON.parse(raw);
    return guard(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

export function writeStore(store: "local" | "session", key: string, value: unknown): void {
  try {
    const s = store === "local" ? window.localStorage : window.sessionStorage;
    if (value === undefined || value === null) s.removeItem(key);
    else s.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable: the value just isn't remembered */
  }
}

export const isString = (v: unknown): v is string => typeof v === "string";
export const isBoolean = (v: unknown): v is boolean => typeof v === "boolean";
